var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategorySatellite32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/Satellite_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E27AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/Satellite_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-22",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Satellite_32",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0467316,19.319 C23.5377316,20.202 21.7437316,21.058 19.7307316,21.83 C15.6897316,23.38 11.0297316,24.435 7.48973157,24.486 C9.16773157,27.184 12.1507316,28.99 15.5557316,28.99 C20.7937316,28.99 25.0557316,24.729 25.0557316,19.49 C25.0557316,19.432 25.0477316,19.377 25.0467316,19.319 M5.82373157,23.416 C5.33273157,22.202 5.05573157,20.879 5.05573157,19.49 C5.05573157,19.375 5.06873157,19.263 5.07273157,19.148 C3.80373157,20.177 3.05673157,21.129 3.00273157,21.828 C2.98173157,22.115 3.07673157,22.352 3.30673157,22.572 C3.76073157,23.008 4.64073157,23.291 5.82373157,23.416 M6.05573157,19.49 C6.05573157,20.919 6.38173157,22.27 6.94873157,23.486 C10.0187316,23.547 14.5357316,22.751 19.3727316,20.897 C21.6437316,20.026 23.5007316,19.106 24.9597316,18.213 C24.3317316,13.578 20.3597316,9.99 15.5557316,9.99 C10.3177316,9.99 6.05573157,14.252 6.05573157,19.49 M26.3927316,10.153 C25.9717316,9.733 25.2887316,9.736 24.8697316,10.153 C24.4507316,10.573 24.4507316,11.256 24.8697316,11.675 C25.2897316,12.094 25.9727316,12.094 26.3927316,11.675 C26.8117316,11.256 26.8117316,10.573 26.3927316,10.153 M29.3637316,12.583 C29.8977316,13.095 30.1007316,13.748 29.9537316,14.472 C29.6917316,15.767 28.2637316,17.266 26.0167316,18.724 C26.0347316,18.978 26.0557316,19.232 26.0557316,19.49 C26.0557316,25.28 21.3457316,29.99 15.5557316,29.99 C11.5657316,29.99 8.08973157,27.753 6.31373157,24.467 C4.66573157,24.372 3.35473157,24.005 2.61273157,23.293 C2.17173157,22.868 1.96173157,22.335 2.00573157,21.752 C2.09573157,20.589 3.17873157,19.255 5.20573157,17.788 C6.02473157,12.807 10.3467316,8.99 15.5557316,8.99 C20.7047316,8.99 24.9907316,12.719 25.8787316,17.617 C27.7777316,16.316 28.8037316,15.116 28.9737316,14.274 C29.0527316,13.886 28.9567316,13.578 28.6717316,13.304 C28.4577316,13.113 27.3437316,12.492 27.0557316,12.49 L27.0557316,12.418 C26.6567316,12.796 26.1457316,12.989 25.6317316,12.989 C25.0997316,12.989 24.5677316,12.787 24.1627316,12.383 L24.1627316,12.382 C23.3547316,11.573 23.3547316,10.256 24.1627316,9.446 C24.9727316,8.638 26.2897316,8.636 27.0997316,9.446 C27.6817316,10.029 27.8377316,10.872 27.5827316,11.601 C28.2997316,11.841 29.1917316,12.417 29.3637316,12.583 M25.0967316,6.99 C26.1027316,6.99 27.0517316,7.468 27.7007316,8.3 L28.4897316,7.685 C27.6497316,6.608 26.4117316,5.99 25.0967316,5.99 C23.7787316,5.99 22.5407316,6.61 21.6997316,7.689 L22.4887316,8.303 C23.1387316,7.469 24.0897316,6.99 25.0967316,6.99 M30.5387316,6.252 L29.6507316,6.711 C28.7857316,5.039 27.0407316,4 25.0977316,4 C23.1507316,4 21.4037316,5.042 20.5387316,6.719 L19.6507316,6.261 C20.6877316,4.25 22.7747316,3 25.0977316,3 C27.4167316,3 29.5017316,4.246 30.5387316,6.252",
    id: "Satellite_Category-Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategorySatellite32);
export default __webpack_public_path__ + "static/media/Arch-Category_Satellite_32.22b57826c9b2d0a9a4d30878ae0b0d6f.svg";
export { ForwardRef as ReactComponent };